import React, { Component } from 'react';

import Modal from 'react-modal';
import CheckBox from 'grommet/components/CheckBox';
import Anchor from 'grommet/components/Anchor';
import Button from 'grommet/components/Button';
import Paragraph from 'grommet/components/Paragraph';
import Spinning from 'grommet/components/icons/Spinning';

import FormCreator from '../../../components/UI/FormCreator/FormCreator';
import TermsOfWebsite from '../../TermsOfWebsite/TermsOfWebsite';

import classes from './StepTwo.module.scss';

Modal.setAppElement('#root');
Modal.defaultStyles.overlay.position = 'absolute';

export class StepTwo extends Component {
  state = {
    showModal: false,
    termsOfWebsiteAccepted: false
  };

  handleTermsOfWebisteCheckbox = () => {
    this.setState({
      termsOfWebsiteAccepted: !this.state.termsOfWebsiteAccepted
    });
  };

  openModal = () => {
    this.setState({
      showModal: true
    });
  };

  cancelTermsInModal = () => {
    this.setState({
      showModal: false,
      termsOfWebsiteAccepted: false
    });
  };

  acceptTermsInModal = () => {
    this.setState({
      showModal: false,
      termsOfWebsiteAccepted: true
    });
  };

  renderButtonOrInfo = () => {
    if (!this.state.termsOfWebsiteAccepted) {
      return <Paragraph>Please accept Terms & Conditions of our Website to continue.</Paragraph>;
    }

    if (this.props.registrationLoading) {
      return <Spinning />;
    }

    return (
      <Button
        className={classes.nextStepButton}
        box
        label="Next step"
        secondary={true}
        onClick={this.props.checkFormValidity}
      />
    );
  };

  render() {
    return (
      <>
        <Modal isOpen={this.state.showModal} className="ss-modal">
          <div className="grommet">
            <TermsOfWebsite inModal />
          </div>

          <Button className={classes.nextStepButton} box label="Agree" secondary onClick={this.acceptTermsInModal} />

          <Button className={classes.nextStepButton} box label="Cancel" primary onClick={this.cancelTermsInModal} />
        </Modal>

        <div className={classes.termsOfWebsiteContainer}>
          <CheckBox
            checked={this.state.termsOfWebsiteAccepted}
            onChange={this.handleTermsOfWebisteCheckbox}
            label={
              <Anchor
                onClick={this.openModal}
                data-cy="signup_accept_tnc"
                label="Accept Terms & Conditions of our Website"
              />
            }
          />
        </div>

        <FormCreator formData={this.props.personalDetails} valueChanged={this.props.valueChangedHandler} />

        <div className={classes.checkboxContainer}>
          <CheckBox
            checked={this.props.marketing}
            onChange={() => {
              this.props.toggleCheckbox('marketing', !this.props.marketing);
            }}
            label="We'd love to keep you up to date with our news & offers, tick here if you'd like to stay in touch"
          />
        </div>

        {this.renderButtonOrInfo()}
      </>
    );
  }
}

export default StepTwo;
